import React, { useEffect, useState } from "react";

// Mui
import {
    Box,
    Typography,
    Modal,
    IconButton,
    Grid,
    Card,
    CardMedia,
    Skeleton
} from "@mui/material";
import { Close } from "@mui/icons-material";
import Swal from 'sweetalert2';

// Services
import ppmServices from '@services/PpmServices';

const ModalImages = ({ setOpenImages, openImages, data }) => {
    const [images, setImages] = useState([]);
    const [loading, setLoading] = useState(true);

    const handleEditModalClose = () => setOpenImages(false);

    useEffect(() => {
        if (!data) return;

        const fetchImages = async () => {
            try {
                setLoading(true);
                const result = await ppmServices.getGalleryByEvent({ idEvento: data?.idEvento });
                const { results, response, message } = result;

                if (results && response?.data?.length > 0) {
                    setImages(response.data);
                } else {
                    throw new Error(message);
                }
            } catch (error) {
                Swal.fire({
                    title: error.message,
                    icon: 'warning',
                    customClass: {
                        container: 'modal-alert',
                    },
                });
            } finally {
                setLoading(false);
            }
        };

        fetchImages();
    }, [data]);

    return (
        <Modal open={openImages} disableEscapeKeyDown>
            <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: { xs: "90%", md: "70%" },
                    height: "80%",
                    bgcolor: "background.paper",
                    borderRadius: 4,
                    boxShadow: 24,
                    overflowY: "auto"
                }}
            >
                <Box sx={{
                    position: "sticky",
                    top: 0,
                    zIndex: 1,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    py: 2,
                    px: 2,
                    bgcolor: "background.paper",
                    paddingRight: 2

                }}>
                    <Typography variant="h6" maxWidth={"80%"}>Galería - {data?.actividad}</Typography>
                    <IconButton onClick={handleEditModalClose}>
                        <Close />
                    </IconButton>
                </Box>

                <Grid container spacing={2} sx={{ px: 4, my: 2, maxHeight: { xs: "65vh", md: "100vh" }, overflowY: "auto", alignItems: "center" }}>
                    {loading ? (
                        Array.from({ length: 4 }).map((_, index) => (
                            <Grid item xs={12} md={6} key={index}>
                                <Skeleton variant="rectangular" height="230px" />
                            </Grid>
                        ))
                    ) : (
                        images.map((image) => (
                            <Grid item xs={12} md={6} key={image.id}>
                                <Card sx={{ height: '100%' }}>
                                    <CardMedia
                                        component="img"
                                        alt={image.imageName}
                                        height="230"
                                        image={image.imagePath}
                                        sx={{ objectFit: 'cover' }}
                                    />
                                </Card>
                            </Grid>
                        ))
                    )}
                </Grid>
            </Box>
        </Modal>
    );
};

export default ModalImages;
